import React, { useState } from 'react';
import { brand } from '../theme/brand';
import logoUrl from '../assets/spie-logo.png';

/**
 * Renders the SPIE org logo (imported so Vite fingerprints and bundles it).
 * If the image fails to load at runtime, falls back to a styled text wordmark
 * so the header never shows a broken image.
 */
export default function BrandMark({ height = 36 }: { height?: number }) {
    const [imgFailed, setImgFailed] = useState(false);

    if (imgFailed) {
        return (
            <span
                style={{
                    fontWeight: 800,
                    fontSize: height * 0.6,
                    letterSpacing: 1,
                    color: brand.navy,
                }}
            >
                SPIE
            </span>
        );
    }

    return (
        <img
            src={logoUrl}
            alt="SPIE — Supply Chain Product Innovation & Engineering"
            style={{ height, width: 'auto', display: 'block' }}
            onError={() => setImgFailed(true)}
        />
    );
}

BrandMark.defaultProps = {
    height: 36,
};
